import config from "../config";

let wheelId = 1;// Varsayılan değer
let wheelIdLoaded = false;
let wheelIdLoadingPromise = null;
let bonusProcess = '';
const baseHostname = window.location.host.split(".")[0];

const getKeys = async (body) => {
  if (typeof window.rh === 'undefined' || typeof window.rh.cr !== 'function') {
    return ['', ''];
  }
  try {
    return await Promise.race([
      window.rh.cr(body),
      new Promise((resolve) => setTimeout(() => resolve(['', '']), 5000))
    ]);
  } catch {
    return ['', ''];
  }
};

const loadWheelConfig = async () => {
  if (wheelIdLoadingPromise) {
    return wheelIdLoadingPromise;
  }
  

  wheelIdLoadingPromise = new Promise(async (resolve) => {
    try {
      let body = JSON.stringify({
        process_id: 'get-cark-config',
        user_id: baseHostname,
        recaptcha: "test"
      });
      let keys = await getKeys(body);
      const response = await fetch(`${config.apiBaseUrlAdvanced}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });
      const data = await response.json();
      wheelId = data.spinWheelId;
      bonusProcess = data.requestProcess;
      wheelIdLoaded = true;
      resolve();
    } catch (error) {
      console.error('WheelConfig yüklenirken hata:', error);
      wheelIdLoaded = true; // Hata durumunda varsayılan değeri kullan
      resolve();
    }
  });

  return wheelIdLoadingPromise;
};

// Servis başlatıldığında config'i yükle
loadWheelConfig();

// wheelId kullanılan her servis için wrapper fonksiyon
const ensureWheelIdLoaded = async (callback) => {
  if (!wheelIdLoaded) {
    await loadWheelConfig();
  }
  return callback();
};

export const validateUser = async (userId) => {
  return ensureWheelIdLoaded(async () => {
    if (!userId) {
      console.error('User ID bulunamadı');
      return null;
    }

    try {
      let body = JSON.stringify({
        process_id: 'get-user',
        user_id: userId,
        recaptcha: 'test'
      });
      let keys = await getKeys(body);
      const validationResponse = await fetch(`${config.apiBaseUrlAdvanced}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });

      if (!validationResponse.ok) {
        throw new Error('Validation response was not ok');
      }

      const data = await validationResponse.json();
      
      // API'den gelen yanıtın geçerli olup olmadığını kontrol et
      if (!data || data.error || data.status === false) {
        console.error('Validation failed:', data?.message || data?.error || 'Invalid response');
        return null;
      }

      return data;
    } catch (error) {
      console.error('Kullanıcı doğrulama hatası:', error);
      return null;
    }
  });
};

export const fetchUserData = async (userId) => {
  return ensureWheelIdLoaded(async () => {
    try {
      let body = JSON.stringify({
        user_id: userId,
        recaptcha: 'test',
        cark_obj_id: wheelId
      });
      let keys = await getKeys(body);
      const response = await fetch(`${config.apiBaseUrl}user_data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });

      if (!response.ok) {
        throw new Error('User data response was not ok');
      }

      const result = await response.json();
      return result.data;
    } catch (error) {
      console.error('Kullanıcı bilgileri getirme hatası:', error);
      return null;
    }
  });
};

// Yeni bir fonksiyon: CSS config'i getir
export const fetchCssConfig = async () => {
  try {
    const response = await fetch(config.cssJsonUrl);
    if (!response.ok) {
      throw new Error('CSS config response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('CSS config getirme hatası:', error);
    return null;
  }
};

// Yeni bir fonksiyon: Çark datası getir
export const fetchWheelData = async () => {
  try {
    const response = await fetch(config.jsonUrl);
    if (!response.ok) {
      throw new Error('Wheel data response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('Çark datası getirme hatası:', error);
    return null;
  }
};

// Çark segmentlerini getir
export const fetchSegments = async () => {
  return ensureWheelIdLoaded(async () => {
    try {
      let body = JSON.stringify({
        cark_obj_id: wheelId,
      });
      let keys = await getKeys(body);
      const response = await fetch(`${config.apiBaseUrl}cark_data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });

      if (!response.ok) {
        throw new Error('Segments response was not ok');
      }

      const data = await response.json();
      return data.segments;
    } catch (error) {
      console.error('Çark segmentleri getirme hatası:', error);
      return null;
    }
  });
};

// Admin login fonksiyonu
export const adminLogin = async (username, password) => {
  try {
    let body = JSON.stringify({
      username,
      password
    });
    let keys = await window.rh.cr(body);
    const response = await fetch(`${config.adminApi}login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        "hk": keys[0],
        "hh": keys[1]
      },
      credentials: 'include',
      body: body
    });

    const data = await response.json();

    // "Zaten oturumun açık" mesajı gelirse de başarılı kabul et
    if (data.message === "Zaten oturumun açık") {
      return {
        success: true,
        data: data,
        message: "Zaten oturumun açık!"
      };
    }

    // Normal hata kontrolü
    if (!response.ok || data.status === false) {
      throw new Error(data.message || 'Giriş başarısız');
    }

    return {
      success: true,
      data: data
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Giriş yapılırken bir hata oluştu'
    };
  }
};

// CSS değişikliklerini kaydetme fonksiyonu
export const saveCssChanges = async (cssData) => {
  try {
    const response = await fetch(`${config.adminApi}set_cark_css`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',

      body: JSON.stringify({
        data: {
          // Genel tasarım
          backgroundGradient1: cssData.backgroundGradient1,
          backgroundGradient2: cssData.backgroundGradient2,
          
          // Header tasarımı
          headerBg: cssData.headerBg,
          headerBorderColor: cssData.headerBorderColor,
          headerIconColor: cssData.headerIconColor,
          headerTextColor: cssData.headerTextColor,
          headerButtonBg: cssData.headerButtonBg,
          headerButtonHoverBg: cssData.headerButtonHoverBg,
          headerItemBg: cssData.headerItemBg,
          headerItemText: cssData.headerItemText,
          headerItemBorder: cssData.headerItemBorder,
          headerItemHoverBg: cssData.headerItemHoverBg,
          headerItemHoverBorder: cssData.headerItemHoverBorder,
          
          // Buton tasarımı
          buttonGradient1: cssData.buttonGradient1,
          buttonGradient2: cssData.buttonGradient2,
          buttonTextColor: cssData.buttonTextColor,
          buttonBorderColor: cssData.buttonBorderColor,
          buttonGlowColor: cssData.buttonGlowColor,
          buttonDisabled1: cssData.buttonDisabled1,
          buttonDisabled2: cssData.buttonDisabled2,
          buttonDisabledText: cssData.buttonDisabledText,
          buttonDisabledBorder: cssData.buttonDisabledBorder,
          
          // Çark tasarımı
          backgroundColor1: cssData.backgroundColor1,
          backgroundColor2: cssData.backgroundColor2,
          spinButtonFont: cssData.spinButtonFont ?? "Poppins",
          wheelSlicesFont: cssData.wheelSlicesFont ?? "Montserrat",
          wheelSlicesFontSize: cssData.wheelSlicesFontSize ?? 20,
          textColor1: cssData.textColor1,
          textColor2: cssData.textColor2,
          borderColor: cssData.borderColor,
          pointerColor: cssData.pointerColor,
          wheelGlowColor: cssData.wheelGlowColor,
          wheelGlowOpacity: cssData.wheelGlowOpacity,
          radiusLineColor: cssData.radiusLineColor,
          
          // Modal tasarımı (Tebrikler modalı)
          modalBg: cssData.modalBg,
          modalBorderColor: cssData.modalBorderColor,
          modalHeaderColor: cssData.modalHeaderColor,
          modalTextColor: cssData.modalTextColor,
          modalButtonGradient1: cssData.modalButtonGradient1,
          modalButtonGradient2: cssData.modalButtonGradient2,
          modalButtonText: cssData.modalButtonText,
          
          // Geçmiş modal tasarımı
          historyModalBg: cssData.historyModalBg,
          historyModalBorder: cssData.historyModalBorder,
          historyHeaderColor: cssData.historyHeaderColor,
          historyCloseColor: cssData.historyCloseColor,
          historyDateColor: cssData.historyDateColor,
          historyBadgeBg: cssData.historyBadgeBg,
          historyBadgeText: cssData.historyBadgeText,
          historyInfoLabel: cssData.historyInfoLabel,
          historyInfoValue: cssData.historyInfoValue,
          historyNoteColor: cssData.historyNoteColor,
          historyItemBg: cssData.historyItemBg,
          historyItemBorder: cssData.historyItemBorder,
          historyHeaderBg: cssData.historyHeaderBg,

          // Arkaplan görseli
          customBgEnabled: cssData.customBgEnabled ?? false,
          customBgImage: cssData.customBgImage ?? null,

          // Özel logo görseli + boyut/margin
          customLogoEnabled: cssData.customLogoEnabled ?? false,
          customLogoImage: cssData.customLogoImage ?? null,
          logoWidth: cssData.logoWidth ?? 0,
          logoHeight: cssData.logoHeight ?? 0,
          logoMarginTop: cssData.logoMarginTop ?? 0,
          logoMarginBottom: cssData.logoMarginBottom ?? 0,
          logoMarginLeft: cssData.logoMarginLeft ?? 0,
          logoMarginRight: cssData.logoMarginRight ?? 0,
          logoPaddingTop: cssData.logoPaddingTop ?? 0,
          logoPaddingBottom: cssData.logoPaddingBottom ?? 0,
          logoPaddingLeft: cssData.logoPaddingLeft ?? 0,
          logoPaddingRight: cssData.logoPaddingRight ?? 0,

          // Özel avatar görseli (Hoşgeldiniz yanındaki kullanıcı görseli)
          customAvatarEnabled: cssData.customAvatarEnabled ?? false,
          customAvatarImage: cssData.customAvatarImage ?? null,

          // Header granular tema alanları (Faz A)
          welcomeBg: cssData.welcomeBg ?? null,
          welcomeBorder: cssData.welcomeBorder ?? null,
          welcomeBorderHover: cssData.welcomeBorderHover ?? null,
          avatarBorder: cssData.avatarBorder ?? null,
          avatarGlow: cssData.avatarGlow ?? null,
          avatarBgColor: cssData.avatarBgColor ?? null,
          greetingColor: cssData.greetingColor ?? null,
          usernameColor: cssData.usernameColor ?? null,
          subtitleColor: cssData.subtitleColor ?? null,
          chipBg: cssData.chipBg ?? null,
          chipBorder: cssData.chipBorder ?? null,
          chipText: cssData.chipText ?? null,
          actionBtnBg: cssData.actionBtnBg ?? null,
          actionBtnBorder: cssData.actionBtnBorder ?? null,
          actionBtnText: cssData.actionBtnText ?? null,
          actionBtnHoverBg: cssData.actionBtnHoverBg ?? null,
          actionBtnHoverBorder: cssData.actionBtnHoverBorder ?? null,
          actionBtnHoverText: cssData.actionBtnHoverText ?? null,

          // Modal granular tema alanları (Faz B)
          modalOverlayBg: cssData.modalOverlayBg ?? null,
          historyOverlayBg: cssData.historyOverlayBg ?? null,
          noSpinBg: cssData.noSpinBg ?? null,
          noSpinBorder: cssData.noSpinBorder ?? null,
          noSpinTitle: cssData.noSpinTitle ?? null,
          noSpinText: cssData.noSpinText ?? null,
          noSpinX: cssData.noSpinX ?? null,
          noSpinClaimBg: cssData.noSpinClaimBg ?? null,
          noSpinClaimText: cssData.noSpinClaimText ?? null,
          noSpinCancelBg: cssData.noSpinCancelBg ?? null,
          noSpinCancelText: cssData.noSpinCancelText ?? null,
          resetOverlayBg: cssData.resetOverlayBg ?? null,
          resetBg: cssData.resetBg ?? null,
          resetBorder: cssData.resetBorder ?? null,
          resetTitle: cssData.resetTitle ?? null,
          resetText: cssData.resetText ?? null,
          resetCancelBg: cssData.resetCancelBg ?? null,
          resetCancelText: cssData.resetCancelText ?? null,
          resetConfirmBg: cssData.resetConfirmBg ?? null,
          resetConfirmText: cssData.resetConfirmText ?? null,

          // Long footer logo görünürlüğü
          longLogoVisible: cssData.longLogoVisible ?? true,

          // Yeni Tasarım Seçenekleri
          wheelType: cssData.wheelType ?? "cosmic",
          wheelFrameStyle: cssData.wheelFrameStyle ?? "cosmic",
          wheelFrameColor1: cssData.wheelFrameColor1 ?? "#00f0ff",
          wheelFrameColor2: cssData.wheelFrameColor2 ?? "#7000ff",
          centerButtonStyle: cssData.centerButtonStyle ?? "cosmic",
          centerButtonCrystalColor: cssData.centerButtonCrystalColor ?? "#00f0ff",
          centerButtonTextColor: cssData.centerButtonTextColor ?? "#00f0ff",
          pointerStyle: cssData.pointerStyle ?? "cosmic",
          wheelOverlayShine: cssData.wheelOverlayShine ?? true,
          segmentIcons: cssData.segmentIcons ?? {},
        },
        cark_obj_id: wheelId
      })
    });

    if (!response.ok) {
      throw new Error('CSS kaydetme işlemi başarısız');
    }

    const result = await response.json();
    return {
      success: result.status,
      message: result.message
    };

  } catch (error) {
    console.error('CSS kaydetme hatası:', error);
    return {
      success: false,
      message: 'CSS değişiklikleri kaydedilirken bir hata oluştu'
    };
  }
};

// CSS verilerini getirmek için yeni fonksiyon
export const fetchCarkCss = async () => {
  return ensureWheelIdLoaded(async () => {
    try {
      let body = JSON.stringify({
        process_id: 'get-cark-css',
        user_id: wheelId,
        recaptcha: 'test'
      });
      let keys = await getKeys(body);
      const response = await fetch(`${config.apiBaseUrlAdvanced}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });

      if (!response.ok) {
        throw new Error('CSS verisi alınamadı');
      }

      const data = await response.json();
      
      if (!data || data.error || data.status === false) {
        throw new Error(data?.message || data?.error || 'Geçersiz CSS verisi');
      }

      return data;
    } catch (error) {
      console.error('CSS verisi getirme hatası:', error);
      return null;
    }
  });
};

// Default CSS'e dönme fonksiyonu
export const resetToDefaultCss = async () => {
  const defaultCss = {
    backgroundColor1: "#0b1528",
    backgroundColor2: "#0f2347",
    textColor1: "#00f0ff",
    textColor2: "#d4af37",
    borderColor: "#00f0ff",
    pointerColor: "#00f0ff",
    wheelGlowColor: "#00f0ff",
    wheelGlowOpacity: 0.35,
    radiusLineColor: "rgba(0, 240, 255, 0.4)",
    buttonGradient1: "#0b1528",
    buttonGradient2: "#0f2347",
    buttonTextColor: "#00f0ff",
    buttonBorderColor: "#00f0ff",
    buttonGlowColor: "#00f0ff",
    buttonDisabled1: "#101f38",
    buttonDisabled2: "#0a1324",
    buttonDisabledText: "#1e3b6e",
    buttonDisabledBorder: "#101f38",
    headerBg: "rgba(11, 21, 40, 0.7)",
    headerBorderColor: "rgba(0, 240, 255, 0.15)",
    backgroundGradient1: "#070c16",
    backgroundGradient2: "#0c1527",
    headerItemBg: "rgba(11, 21, 40, 0.6)",
    headerItemText: "#ffffff",
    headerItemBorder: "rgba(0, 240, 255, 0.15)",
    headerItemHoverBg: "rgba(11, 21, 40, 0.8)",
    headerItemHoverBorder: "rgba(0, 240, 255, 0.45)",
    headerEmojiColor: "#00f0ff",
    headerIconColor: "#00f0ff",
    headerTextColor: "#ffffff",
    headerButtonBg: "rgba(11, 21, 40, 0.7)",
    headerButtonHoverBg: "rgba(11, 21, 40, 0.8)",
    // Modal tasarımı (Tebrikler modalı)
    modalBg: "#0b1528",
    modalBorderColor: "#00f0ff",
    modalHeaderColor: "#FFFFFF",
    modalTextColor: "#e2e8f0",
    modalButtonGradient1: "#0b1528",
    modalButtonGradient2: "#0f2347",
    modalButtonText: "#FFFFFF",
    // Geçmiş modal tasarımı
    historyModalBg: "#0b1528",
    historyModalBorder: "#00f0ff",
    historyHeaderColor: "#FFFFFF",
    historyCloseColor: "#FFFFFF",
    historyDateColor: "#64748b",
    historyBadgeBg: "#00f0ff",
    historyBadgeText: "#0b1528",
    historyInfoLabel: "#64748b",
    historyInfoValue: "#cbd5e1",
    historyNoteColor: "#64748b",
    historyItemBg: "#0f2347",
    historyItemBorder: "#00f0ff",
    historyHeaderBg: "#0b1528",
    // Yazı tipleri
    spinButtonFont: "Poppins",
    wheelSlicesFont: "Montserrat",
    wheelSlicesFontSize: 20,
    // Long footer logo görünürlüğü
    longLogoVisible: true,
    // Yeni Tasarım Seçenekleri
    wheelType: "cosmic",
    wheelFrameStyle: "cosmic",
    wheelFrameColor1: "#00f0ff",
    wheelFrameColor2: "#7000ff",
    centerButtonStyle: "cosmic",
    centerButtonCrystalColor: "#00f0ff",
    centerButtonTextColor: "#00f0ff",
    pointerStyle: "cosmic",
    wheelOverlayShine: true,
    segmentIcons: {}
  };

  try {
    const response = await fetch(`${config.adminApi}set_cark_css`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({
        data: defaultCss,
        cark_obj_id: wheelId
      })
    });

    const data = await response.json();

    if (!response.ok || data.status === false) {
      throw new Error(data.message || 'Varsayılan CSS ayarlarına dönülemedi');
    }

    return {
      success: true,
      message: 'Varsayılan CSS ayarlarına başarıyla dönüldü',
      data: defaultCss
    };
  } catch (error) {
    console.error('CSS sıfırlama hatası:', error);
    return {
      success: false,
      message: error.message || 'Varsayılan CSS ayarlarına dönülürken bir hata oluştu'
    };
  }
};

// Kullanıcı geçmişini getiren fonksiyon
export const fetchUserHistory = async (userId) => {
  return ensureWheelIdLoaded(async () => {
    try {
      let body = JSON.stringify({
        user_id: userId,
        cark_obj_id: wheelId
      });
      let keys = await getKeys(body);
      const response = await fetch(`${config.apiBaseUrl}user_gecmis`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });

      if (!response.ok) {
        throw new Error('History response was not ok');
      }

      const result = await response.json();
      return result.data;
    } catch (error) {
      console.error('Kullanıcı geçmişi getirme hatası:', error);
      return null;
    }
  });
};

export const sendSpinCountRequest = async (userId) => {
  return ensureWheelIdLoaded(async () => {
    try {
      let body = JSON.stringify({
        user_id: userId,
        process_id: bonusProcess,
        recaptcha: "test"
      });
      let keys = await getKeys(body);
      const response = await fetch(`${config.apiBaseUrl2}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });

      if (!response.ok) {
        throw new Error('History response was not ok');
      }

      const result = await response.json();
      // Tüm API yanıtını döndür, sadece data kısmını değil
      return result;
    } catch (error) {
      console.error('Bonusİsteği Hatası:', error);
      return {
        status: false,
        message: 'Hak talep edilirken bir hata oluştu',
        data: null
      };
    }
  });
};

// Çarkı çevirmek için API isteği
export const spinWheel = async (userId) => {
  return ensureWheelIdLoaded(async () => {
    try {
      let body = JSON.stringify({
        user_id: userId,
        cark_obj_id: wheelId
      });
      let keys = await getKeys(body);
      const response = await fetch(`${config.apiBaseUrl}cevir`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });

      if (!response.ok) {
        throw new Error('Çark çevirme işlemi başarısız');
      }

      const result = await response.json();
      
      if (!result.status) {
        throw new Error(result.message || 'Çark çevirme işlemi başarısız');
      }

      return {
        success: true,
        prize: result.data.win,
        remainingSpins: result.data.spin_count
      };

    } catch (error) {
      console.error('Çark çevirme hatası:', error);
      return {
        success: false,
        message: error.message
      };
    }
  });
};
